import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { useStoreActions } from 'easy-peasy';
import { InfoToast } from 'components/toast';
import { meQuery } from 'components/auth/graphql/query/User';

import { fetchQuery, environment } from 'utils/relay';
import routes from 'routes';

const mutation = graphql`
  mutation LoginAuthMutation($username: String!, $password: String!) {
    tokenAuth(username: $username, password: $password) {
      token
      user{
        id
        username
        userCategory
        userAccess
      }
    }
  }
`;

const Login = ({ history, location: { state } }) => {

	const [email, setEmail] = useState(state ? state.user.email : '');
	const [password, setPassword] = useState('');
	const [errorMessage, setErrorMessage] = useState('');
	const updateAuthToken = useStoreActions(actions => actions.updateAuthToken);

	function handleSubmit(e) {
		e.preventDefault();
		const formData = {
			username: email.toLowerCase(),
			password: password
		};
		commitMutation(
			environment,
			{
				mutation,
				variables: formData,
				onCompleted: function ({ tokenAuth }, errors) {
					if (errors) {
						var messages = [];
						errors.forEach((error) => { messages.push(error.message); });
						messages = messages.join('; ');
						setErrorMessage(messages);
						return;
					}
					else if(!tokenAuth.user.userAccess){
						InfoToast('Your account is deactivated, please contact support');
						return;
					}
					updateAuthToken(tokenAuth.token);
					fetchQuery(meQuery)
						.then(({ me }) => {
							const userDetails = JSON.parse(me);
							if (userDetails)
								history.push(`${routes.inbox}${routes.client}/${userDetails.client_id}`);
							else
								history.push('/');
						});
				}
			}
		);
	}

	return (
		<section className="login m-auto d-block">
			<div className="login__login-header text-center">
				<Link to="/" className="logo">
					<img src="/img/new-logo/enquirybot-logo.png12.png" alt="" width="250px" height="auto" />
				</Link>
			</div>
			<div className="login__container m-auto">
				{/* <div className="login__header">
					<Link to="/" className="logo text-center">
						<img src="/img/new-logo/enquirybot-logo.png12.png" alt="" width="250px" height="auto"/>
					</Link>
				</div> */}
				<div className="login__body mt-15">
					<h1 className="heading-level1 mb-10">Login</h1>
					<p className="desc mb-20">Please enter your credentials</p>
					<form onSubmit={handleSubmit}>
						<div className="input-wrap">
							<input
								type="text"
								className="input-field mb-15"
								placeholder="me@email.com"
								value={email}
								onChange={e => setEmail(e.target.value)}
								name="email"
								id="login-page-username"
							/>
							<input
								type="password"
								value={password}
								onChange={e => setPassword(e.target.value)}
								className="input-field"
								placeholder="password"
								name="password"
								id="login-page-password"
							/>
						</div>
						{errorMessage && <p className="desc mb-10" style={{ color: 'red' }}>{errorMessage}</p>}
						<div className="btn-wrap mb-20">
							<button id="login-page-submit-btn" type="submit" className="btn btn--primary btn--lg w-100 text-uppercase">
                Login
							</button>
						</div>
					</form>
					<div className="forget-pwd-txt text-center d-flex-v-center">
            Forgot Password?
						<NavLink to={routes.forgotPassword} className="link">&nbsp;Click Here</NavLink>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Login;
